import { EditTwoTone } from "@mui/icons-material";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, IconButton, TableCell, Tooltip, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import DeleteConfirmation from "src/Utils/DeleteConfirmation";

type IProps = {
	handleViewFun?: () => void;
	handleEditFun?: () => void;
	handleDeleteFun?: (...args: any[]) => any;
	handleDeleteModalClose?: () => void;
	viewLink?: string;
	editLink?: string;
	showView?: boolean;
	showEdit?: boolean;
	showDelete?: boolean;
	align?: "center" | "left" | "right" | "justify" | "inherit";
	deleteElement?: boolean;
	loading?: boolean;
};
const TableActions = ({
	handleDeleteFun,
	handleEditFun,
	handleViewFun,
	handleDeleteModalClose,
	viewLink,
	editLink,
	showView,
	showDelete,
	showEdit,
	align = "left",
	deleteElement = false,
	loading = false,
}: IProps) => {
	const theme = useTheme();

	return (
		<TableCell align={align}>
			<Box>
				{showView && (
					<Link to={viewLink || ""}>
						<Tooltip
							title="View"
							arrow
							onClick={() => handleViewFun && handleViewFun()}
						>
							<IconButton
								sx={{
									"&:hover": {
										background:
											theme.colors.primary.lighter,
									},
									color: theme.palette.primary.main,
								}}
								size="small"
							>
								<VisibilityIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Link>
				)}

				{showEdit && (
					<Link to={editLink || ""}>
						<Tooltip
							title="Update"
							arrow
							onClick={() => handleEditFun && handleEditFun()}
						>
							<IconButton
								sx={{
									"&:hover": {
										background: theme.colors.error.lighter,
									},
									color: theme.palette.error.main,
								}}
								size="small"
							>
								<EditTwoTone color="action" fontSize="small" />
							</IconButton>
						</Tooltip>
					</Link>
				)}

				{showDelete &&
					(deleteElement ? (
						<IconButton
							sx={{ padding: 0.5 }}
							size="small"
							color="error"
							onClick={handleDeleteFun}
							disabled={loading}
						>
							<DeleteTwoToneIcon fontSize="small" />
						</IconButton>
					) : (
						<DeleteConfirmation
							handleClose={() =>
								handleDeleteModalClose &&
								handleDeleteModalClose()
							}
							text="Want to delete this?"
							handleDeleteFun={() =>
								handleDeleteFun && handleDeleteFun()
							}
							loading={loading}
						/>
					))}
			</Box>
		</TableCell>
	);
};

export default TableActions;
